
export default {

    getBase64(file: any) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => {
            let encoded = reader.result!.toString().replace(/^data:(.*,)?/, '');
            if ((encoded.length % 4) > 0) {
              encoded += '='.repeat(4 - (encoded.length % 4));
            }
            resolve(encoded);
          };
          reader.onerror = error => reject(error);
        });
      },

    encodeXml(s: any) {
        if (s === undefined) {
            return ('');
        } else {
            const charMap = {
                '<': '&lt;',
                '>': '&gt;',
                '&': '&amp;',
                '"': '&' + 'quot;'
            };
            s = s.toString();
            s = s.replace(/\u00A0/g, ' ');

            function hasKey<O>(obj: O, key: keyof any): key is keyof O {
                return key in obj;
            }

            const escaped = s.replace(/[<>&"]/g, (ch: any) => {
                if (hasKey(charMap, ch)) {
                    return charMap[ch];
                }
            });
            return escaped;
        }
    },

    stringNthField(s: any, chdelim: any, n: any) {
        const splits = s.split(chdelim);
        if (splits.length >= n) {
            return splits[n - 1];
        }
        return ('');
    },

    stringMid(s: any, ix: any, len: any) {
        return (s.substr(ix - 1, len));
    },

    getBoolean(val: any) {
        switch (typeof (val)) {
            case 'string':
                if (val === '1') {
                    return (true);
                }
                if (val.toLowerCase() === 'true') {
                    return (true);
                }
                break;
            case 'boolean':
                return (val);
            case 'number':
                if (val === 1) {
                    return (true);
                }
                break;
        }
        return (false);
    }

};
